import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { getMinimalStore } from '../../utils';
import RuleDetails from '../RuleDetails/RuleDetails';
import { RulesDashboard } from '../RulesDashboard';

const queryClient = new QueryClient();
const store = getMinimalStore();

function Routes() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <IntlProvider locale='en'>
          <BrowserRouter basename='/rule-recommendations'>
            <Switch>
              <Route exact path='/' component={RulesDashboard} />
              <Route exact path='/rule-details/:id' component={RuleDetails} />
            </Switch>
          </BrowserRouter>
        </IntlProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default Routes;
